import { Modal, Box, Button } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation, Trans } from 'react-i18next';
import './FacebookPermissionModal.css';
import './SocialConnectModal.css';

const FacebookPermissionModal = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="social-connect-modal"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          width: isMobile ? '90%' : '90%',
          maxWidth: 550,
          outline: 'none',
        }}
      >
        <Box className="social-connect-modal-header" sx={{ px: isMobile ? 2.5 : 4, py: 2, borderBottom: '1px solid #f0f0f0' }}>
        <div className="fb-permission-modal-header" style={{ marginBottom: 0 }}>
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ color: '#ff9800', fontSize: '2.5rem' }}
          />
          <h3 className="fb-permission-modal-title">
            {t('fb_perm_title')}
          </h3>
        </div>
        </Box>

        <Box className="social-connect-modal-body" sx={{ p: isMobile ? 2.5 : 4 }}>
        <div className="fb-permission-warning-box">
          <div className="fb-permission-warning-content">
            <p>
              {t('fb_perm_intro')}
            </p>
          </div>
        </div>

        <div className="fb-permission-steps">
          <h4 className="fb-permission-steps-title">{t('fb_perm_steps_title')}</h4>
          <ol className="fb-permission-steps-list">
            <li>
              <Trans
                i18nKey="fb_perm_step1_html"
                components={{
                  fblink: <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" />,
                  strong: <strong />,
                }}
              />
            </li>
            <li>
              {t('fb_perm_step2')}
            </li>
            <li>
              <Trans i18nKey="fb_perm_step3_html" components={{ strong: <strong /> }} />
            </li>
            <li>
              <Trans i18nKey="fb_perm_step4_html" components={{ strong: <strong /> }} />
            </li>
            <li>
              <Trans i18nKey="fb_perm_step5_html" components={{ strong: <strong /> }} />
            </li>
            <li className="fb-permission-final-step">
              <FontAwesomeIcon icon={faArrowRight} className="fb-permission-arrow-icon" />
              <Trans i18nKey="fb_perm_step6_html" components={{ strong: <strong /> }} />
            </li>
          </ol>
        </div>

        </Box>
        <div className="fb-permission-modal-actions social-connect-modal-footer">
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: '#5616ea',
              '&:hover': { backgroundColor: '#4a14d6' },
              width: '100%',
              padding: '12px',
              fontSize: '1rem',
              fontWeight: 600,
            }}
          >
            {t('fb_perm_understand')}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default FacebookPermissionModal;
